<template>
    <div class="content">
        <div class="content_box tableParent public_box">
            <div class="search_box">
                <el-form :inline="true" :model="navForm" class="demo-form-inline">
                    <el-form-item label="车牌号/车架号/设备编号:">
                        <el-input class="width_150" v-model="navForm.keyWord" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.deviceType" placeholder="请选择" size="small" class="width_150" @change="handleDeviceTypeChange">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getVehicleInfo" size="small" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick" v-if="0">
                <el-tab-pane label="车辆实时位置" name="second"></el-tab-pane>
            </el-tabs>
            <!-- 实时位置 -->
            <el-descriptions>
                <el-descriptions-item label="车牌号">{{ detailForm && detailForm.plateNo ? detailForm.plateNo : '' }}</el-descriptions-item>
                <el-descriptions-item label="设备编号">{{ detailForm && detailForm.deviceNumber ? detailForm.deviceNumber : '' }}</el-descriptions-item>
                <el-descriptions-item label="最近定位时间">{{ detailForm && detailForm.lastDataTime ? detailForm.lastDataTime : '' }}</el-descriptions-item>
                <el-descriptions-item label="车辆状态">{{ detailForm && detailForm.onlineStatus ? detailForm.onlineStatus : '' }}</el-descriptions-item>
                <el-descriptions-item label="插拔状态">{{ detailForm && detailForm.plugginStatus ? detailForm.plugginStatus : '' }}</el-descriptions-item>
                <el-descriptions-item v-if="detailForm && detailForm.plugginStatus && detailForm.plugginStatus == '插入'" :label="detailForm && detailForm.plugginStatus && detailForm.plugginStatus == '插入' ? '插入时间' : '拔出时间'">{{ detailForm && detailForm.lastInsetTime ? detailForm.lastInsetTime : '' }}</el-descriptions-item>
                <el-descriptions-item v-if="detailForm && detailForm.plugginStatus && detailForm.plugginStatus == '拔出'" :label="detailForm && detailForm.plugginStatus && detailForm.plugginStatus == '插入' ? '插入时间' : '拔出时间'">{{ detailForm && detailForm.lastPulloutTime ? detailForm.lastPulloutTime : '' }}</el-descriptions-item>
                <el-descriptions-item label="最后位置">{{ detailForm && detailForm.lastAddress ? detailForm.lastAddress : '' }}</el-descriptions-item>
            </el-descriptions>
            <!-- 地图展示 -->
            <div class="dialog_map" v-loading="polylineLoading">
                <MapContainer ref="mapContainer" id="container" :center="center" :mapType="'position'" :zoom="zoom" />
            </div>
        </div>
    </div>
</template>
<script>
import VehicleMap from '@/components/vehicleMap.vue';
import MapContainer from '@/components/MapContainer.vue';
export default {
    components: {
        VehicleMap,
        MapContainer
    },
    data() {
        return {
            polylineLoading: false,
            initLoaded: false,
            activeName: 'second',
            navForm: {
                company: null,
                keyWord: null,
                // keyWord: '68070032919',
                // keyWord: '14149299861',
                deviceType: null
            },
            detailForm: {
                deviceNumber: null,
                plugginStatus: null
            },
            center: { lng: 116.404269, lat: 39.915378 },
            zoom: 18,
            marker: { showFlag: false },
            positionPoint: {},
            // 车辆图标
            positionIcon: {
                url: require('../../../public/images/msi/online/car_icon.png'),
                size: {
                    width: 24,
                    height: 46
                },
                opts: {
                    anchor: {
                        width: 24,
                        height: 46
                    }
                }
            },
            BMap: null,
            BDmap: null
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            return typeData;
        }
    },
    mounted() {},
    methods: {
        initPageByProductType() {
            if (!this.productTypeData || !this.productTypeData.length) {
                return;
            }
            let defaultDeviceType = this.productTypeData[0].metaData;
            this.productTypeData.forEach((item) => {
                if (item.expandInfo) {
                    defaultDeviceType = item.metaData;
                }
            });
            if (this.navForm.deviceType == null) {
                this.navForm.deviceType = defaultDeviceType;
            }
            if (!this.initLoaded) {
                this.initLoaded = true;
                this.queryCurrentTrip();
            }
        },
        queryCurrentTrip() {
            let pageData = this.$route.query;

            if (!pageData.deviceNumber) {
                this.findVehicleNumber();
            } else {
                this.navForm.keyWord = pageData.deviceNumber;
                this.navForm.deviceType = Number(pageData.deviceType);
                this.getVehicleInfo();
            }
        },
        handler({ BMap, map }) {
            this.BMap = BMap;
            this.BDmap = map;
        },
        handleClick() {
            if (this.activeName === 'second' && this.BDmap && this.center.lng && this.center.lat) {
                setTimeout(() => {
                    this.BDmap.setCenter(new this.BMap.Point(this.center.lng, this.center.lat));
                }, 100);
            }
        },
        findVehicleNumber() {
            this.$request({
                method: 'get',
                url: `/ubi/api/vehicle/findTenantSampleVehicle`,
                params: this.navForm.deviceType == 2 ? { deviceType: 1, shortTermRental: true } : this.navForm.deviceType == 1 ? { deviceType: 1, shortTermRental: false } : { deviceType: this.navForm.deviceType }
            }).then((res) => {
                if (res.code == 200) {
                    this.navForm.keyWord = res.data.deviceNumber;
                    this.getVehicleInfo();
                }
            });
        },
        // 切换产品类型
        handleDeviceTypeChange() {
            this.navForm.keyWord = null;
            this.findVehicleNumber();
        },
        // 点击点坐标赋值
        lookDetail() {
            this.marker.showFlag = true;
        },
        // 关闭弹窗
        infoWindowClose() {
            this.marker.showFlag = false;
        },
        // 打开弹窗
        infoWindowOpen() {
            this.marker.showFlag = true;
        },
        // 车辆实时位置
        getVehicleInfo() {
            this.polylineLoading = true;
            this.detailForm = null;
            let locationParams = Object.assign({}, this.navForm);
            if (locationParams.deviceType == 2) {
                locationParams.deviceType = 1;
                locationParams.shortTermRental = true;
            } else if (locationParams.deviceType == 1) {
                locationParams.shortTermRental = false;
            }
            this.$request({
                method: 'get',
                url: `/ubi/api/vehicle/location`,
                params: locationParams
            }).then((res) => {
                this.polylineLoading = false;

                if (res.code == 200 && Object.keys(res.data).length > 0) {
                    this.detailForm = res.data;
                    const lng = res.data.bdLon;
                    const lat = res.data.bdLat;
                    this.positionPoint = { bdLon: lng, bdLat: lat };
                    this.center = { bdLon: lng, bdLat: lat };
                    this.$nextTick(() => {
                        const mapContainer = this.$refs.mapContainer;
                        if (!mapContainer) {
                            return;
                        }
                        const normalizedCenter = mapContainer.normalizeCenter(this.center);
                        mapContainer.initMap(normalizedCenter);
                        if (mapContainer.mapLoaded) {
                            mapContainer.updateCenter(normalizedCenter);
                        }
                    });
                } else {
                    this.$message.error('暂无数据！');
                }
            });
        }
    },
    watch: {
        productTypeData: {
            handler() {
                this.initPageByProductType();
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
.tableParent {
    height: calc(100vh - 90px);
    .vehicle_trip {
        height: 100%;
        overflow: auto;
    }
    .location_box {
        height: 100%;
        overflow: auto;
        .dialog_map {
            #container {
                height: 100% !important;
            }
        }
    }
}
.search_box {
    margin-bottom: -15px;
}
.dialog_map {
    min-height: 400px;
    height: calc(100vh - 200px);
}
#container {
    width: 100%;
    height: 100%;
    min-height: 500px;
    /deep/ .BMap_pop p {
        line-height: 18px;
    }
    /deep/ .BMap_pop p:nth-child(3) {
        display: inline-block;
        width: 300px;
    }
}
</style>
